import { render, staticRenderFns } from "./BookingNotes.vue?vue&type=template&id=79e3dbe9&scoped=true&"
import script from "./BookingNotes.vue?vue&type=script&lang=js&"
export * from "./BookingNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e3dbe9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e3dbe9')) {
      api.createRecord('79e3dbe9', component.options)
    } else {
      api.reload('79e3dbe9', component.options)
    }
    module.hot.accept("./BookingNotes.vue?vue&type=template&id=79e3dbe9&scoped=true&", function () {
      api.rerender('79e3dbe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/booking/BookingNotes.vue"
export default component.exports